const getCastingApiUrl = () => {
  if (process.env.REACT_APP_PANCHANGAM_API_URL) return process.env.REACT_APP_PANCHANGAM_API_URL;
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:8082';
  }
  return 'https://brahminsnet.com:8082';
};

export async function castHoroscopeViaAPI(birthDetails, lang) {
  const apiUrl = getCastingApiUrl();
  const res = await fetch(`${apiUrl}/v1/castHoroscope`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: birthDetails.name,
      date: birthDetails.date,
      time: birthDetails.time,
      place: birthDetails.place,
      latitude: birthDetails.latitude,
      longitude: birthDetails.longitude,
      timezone: birthDetails.timezone,
      lang: lang === 'en' ? 'en' : 'ta',
    }),
    signal: AbortSignal.timeout(20000),
  });
  if (!res.ok) throw new Error('castHoroscope API HTTP ' + res.status);
  const d = await res.json();
  if (!d || !d.success || !d.result) throw new Error('castHoroscope API returned no result');
  return d.result;
}
